import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="dismissible"
export default class extends Controller {
  connect() {
    if (this.#hasId() && this.#isDismissed()) {
      this.element.remove();
      return;
    }
    this.show();
  }

  show() {
    this.element.classList.remove("hidden");
  }

  dismiss() {
    if (this.#hasId()) this.#markDismissed();
    this.element.remove();
  }

  #hasId() {
    return this.element.id && this.element.id.length > 0;
  }

  #storageKey() {
    return `dismissible:${this.element.id}`;
  }

  #isDismissed() {
    try {
      return localStorage.getItem(this.#storageKey()) === "1";
    } catch (_) {
      return false;
    }
  }

  #markDismissed() {
    try {
      localStorage.setItem(this.#storageKey(), "1");
    } catch (_) {}
  }
}
